<template lang="html">
  <div class="tab">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'Tab'
}
</script>

<style lang="sass">
  @import '../stylesheets/base/variables'

  .tab
    width: 100%
    padding: 3px 2px
</style>
